import { render } from "./sales-details.vue?vue&type=template&id=4d63b26d"
import script from "./sales-details.vue?vue&type=script&lang=js"
export * from "./sales-details.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__